jQuery( function ( $ ) {

  const responsive = {
    md: 2,
    xl: 3,
  };

  const slick_options = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: false,
    mobileFirst: true,
    accessibility: false,
    rows: 0,
    adaptiveHeight: true,
  };

  $( 'section.post_cards .slider-wrap' ).each( function () {
    const $wrap = $(this);
    const $slider = $( '.slick-slider', this );

    $slider.on( 'beforeChange', function () {
      $wrap.addClass( 'sliding' );
    });

    $slider.on( 'init', function () {
      ThemeJS.Archive_Items.calculate_content_expansion();
    });

    $slider.on( 'init afterChange', function ( e, slick, index = null ) {
      // slick calls a11y functionality before afterChange
      // we want to remove the slide's tabindex, so we need to disable the a11y option and call it's core function ourselves
      slick.initADA();
      slick.$slides.filter( '.slick-active' ).removeAttr( 'tabindex' ).find( "[data-tabindex='-1'" ).attr( 'tabindex', -1 );
      if ( slick.$prevArrow ?? null ) {
        slick.$prevArrow.add( slick.$nextArrow ).each( function () {
          $(this).attr( 'disabled', $(this).hasClass( 'slick-disabled' ) ).removeAttr( 'aria-disabled' );
        });
      }
      $wrap.removeClass( 'sliding' );
    });

    const num_slides = $( '> *', $slider ).length;

    const options = $.extend( {}, slick_options, true );

    options.prevArrow = $( '.prev', $wrap );
    options.nextArrow = $( '.next', $wrap );
    options.arrows = options.slidesToShow < num_slides;

    options.responsive = Object.entries( responsive ).map( entry => {
      let slidesToShow = parseInt( entry[1] );
      return {
        breakpoint: ThemeJS.Variables.Screen_Sizes[ entry[0] ],
        settings: {
          slidesToShow: slidesToShow,
          slidesToScroll: slidesToShow,
          arrows: slidesToShow < num_slides,
        },
      };
    });

    $slider.slick( options );

  });

});